/**
 * @dependencies: http://kenwheeler.github.io/slick/
 *
 * Initializes slick.js on any element with the js-carousel class.
 */
import 'slick-carousel';
import { isRTL } from '@borngroup/born-utilities';
import * as slickSettings from './module.carousel-settings';
export default class Carousel {
    constructor( query ) {
        let carousels = document.querySelectorAll( query );

        [].forEach.call( carousels, ( carousel ) => {
            this.setupCarousel( carousel );
        });
    }

    /**
     * setupCarousel must be able to be called both in the constructor,
     * for intial setup, and in the fancy reslick situation we have below.
     *
     */
    setupCarousel( carousel, reslick = false ) {
        let $carousel = $(carousel),
            carouselSettings = JSON.parse( carousel.getAttribute( reslick ? 'data-carousel-config' : 'data-slick' )),
            customConfig = slickSettings[ carouselSettings.type ],
            typeSettings = carouselSettings.type && customConfig ? customConfig.options : {},
            defaults = {
                rtl: isRTL() && !carouselSettings.vertical,
                cssEase: carouselSettings.cssEase || 'ease-in-out',
                lazyLoad: 'progressive',
                //Fixes issue introduced on Slick 1.8.0 [https://github.com/kenwheeler/slick/issues/3261]
                rows: 0
            },
            slickDataAttr = carousel.getAttribute( 'data-slick' );

        //Clears the data-slick attribute so that Slick itself doesn't pick it up.
        //DO NOT REMOVE IT NOW, ELSE STYLES DEPENDING ON PRE-INIT SLICK WILL BREAK
        carousel.setAttribute( 'data-slick', '' );

        if ( !reslick ) {
            carousel.setAttribute( 'data-carousel-config', slickDataAttr);
        }

        carouselSettings = $.extend( defaults, typeSettings, carouselSettings );

        if ( customConfig ) {
            for ( let key in customConfig.methods ) {
                $carousel.off( key ).on( key, customConfig.methods[ key ]);
            }
        }

        //Slick's init needs to exist before running .slick();
        $carousel.on( 'init', function(evt, slick) {
            carousel.removeAttribute( 'data-slick' );

            this.setFeatureClasses(slick);
        }.bind(this));

        $carousel.on( 'breakpoint', function(evt, slick) {
            this.setFeatureClasses(slick);
        }.bind(this));

        $carousel.slick( carouselSettings );

        if ( !reslick ) {
            if ( carouselSettings.reslickResponsively ) {
                this.reslickResponsively( $carousel, carouselSettings )
            }
        }

        if ( carouselSettings.sync ) {
            this.setupSync( $carousel, carouselSettings.sync );
        }

        if ( $carousel.hasClass('module-4col') && $carousel.hasClass('force-swipe')) {
            var ts;
            $carousel.data('slider-length', $carousel.children('.slick-list').children('.slick-track').children().length);
            $carousel.on('afterChange', this.onSliderAfterChange);
            $carousel.on('touchstart', function(e) {
                ts = e.originalEvent.touches[0].clientY;
            })
            $carousel.on('touchmove', function(e) {
                var deltaY = e.originalEvent.changedTouches[0].clientY,
                    $currentSlider = $(e.currentTarget),
                    currentSlickIndex = $currentSlider.data('current-slide') || 0;
                if ( (deltaY > ts && currentSlickIndex == 0) || (deltaY < ts && currentSlickIndex == $currentSlider.data('slider-length') - 1) ) {
                    return;
                }
                e.preventDefault();
                if ( ts > deltaY ) {
                    $currentSlider.slick('slickNext');
                } else {
                    $currentSlider.slick('slickPrev');
                }
            })
        }
    }

    onSliderAfterChange( event, slick, currentSlide ) {
        $(event.target).data('current-slide', currentSlide);
    }

    /**
     * Slick doesn't provide a great method to sync sliders AND allow the slidesToScroll to be anything over 1,
     * so this creates an alternate functionality.
     *
     * This also works for custom navigations, i.e. an NodeList that's not a Slick object.
     */

    setupSync( $mainCarousel, syncSelector ) {
        let $nav = $( syncSelector ),
            isSlick = $nav.hasClass( 'is-slick' );

        //This shit works for now.
        if ( isSlick ) {
            let slickInterval = window.setInterval( function() {
                if ( $nav.hasClass( 'slick-slider' )) {
                    this.setupSyncHanlders( $mainCarousel, $nav, isSlick );
                    window.clearInterval( slickInterval );
                }

            }.bind( this ), 100 );
        } else {
            this.setupSyncHanlders( $mainCarousel, $nav, isSlick );
        }
    }

    setupSyncHanlders( $mainCarousel, $nav, isSlick ) {
        let scope = this,
            $navItems = isSlick ? $( $nav.slick( 'getSlick' ).$slides ) : $nav.children();

        $navItems[ 0 ].classList.add( 'slick-nav--active' );

        $mainCarousel.on( 'beforeChange', function( evt, slick, currentSlide, nextSlide ) {
            scope.syncNav( nextSlide, $nav, $navItems, isSlick );
        });

        $navItems.on( 'click focus', function() {
            scope.syncMain.call( this, $mainCarousel, $navItems );
        });
    }

    syncNav( nextSlide, $nav, $navItems, isSlick ) {
        let prevSlide = $nav[ 0 ].querySelector( '.slick-nav--active' ),
            currSlide = $navItems[ nextSlide ];

        if ( isSlick ) {
            $nav.slick( 'slickGoTo', nextSlide );
        }

        prevSlide.classList.remove( 'slick-nav--active' );
        currSlide.classList.add( 'slick-nav--active' );
    }

    syncMain( $mainCarousel, $navItems ) {
        let index = $navItems.index( this );

        $mainCarousel.slick( 'slickGoTo', index );
    }

    /**
     * Adds a special class, "slick-has-arrows", to the carousel element if the current breakpoint
     * has the `arrows` option set to true and the arrows can be displayed.
     * @param  {[type]} slick [description]
     * @return {[type]}       [description]
     */
    setFeatureClasses( slick ) {
        let canScroll = slick.$slides.length > slick.options.slidesToShow,
            hasArrows = slick.options.arrows && canScroll;

        if (!slick.unslicked && hasArrows) {
            slick.$slider[0].classList.add('slick-has-arrows');
        } else {
            slick.$slider[0].classList.remove('slick-has-arrows');
        }

        if (!slick.unslicked && canScroll) {
            slick.$slider[0].classList.add('slick-can-scroll');
        } else {
            slick.$slider[0].classList.remove('slick-can-scroll');
        }
    }

    /**
     * Allows the carousel to unslick at and then reslick based on the breakpoints.
     * Only works with cases with cases with one unslick breakpoint,
     * when the unslick breakpoint is either the max or the min.
     *
     */
    reslickResponsively( $carousel, carouselSettings ) {
        const mobileFirst = carouselSettings.mobileFirst,
            responsiveSettings = carouselSettings.responsive,
            scope = this;

        let responsiveResize = window.addEventListener( 'resize', function( ) {
            [].forEach.call(responsiveSettings, function(child) {
                if ( window.innerWidth <= child.breakpoint && mobileFirst || window.innerWidth >= child.breakpoint && !mobileFirst ) {
                    if ( $carousel[0].slick.unslicked ) {
                        // run the entire slick init process above.
                        scope.setupCarousel($carousel[0], true);
                    }
                }
            })
        });

        return responsiveResize;
    }
}
